var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base, makeList } from '@or-sdk/base';
import { SdkApi } from '@or-sdk/sdk-api';
import { SERVICE_KEY } from './constants';
import { CurrentMultiUserProfile } from './schemas';
export class Users extends Base {
    constructor(params) {
        const { token, discoveryUrl = '', accountId, usersUrl, sdkUrl } = params;
        super({
            token,
            discoveryUrl,
            serviceKey: SERVICE_KEY,
            accountId,
            serviceUrl: usersUrl,
        });
        this.sdkApi = new SdkApi({
            token,
            discoveryUrl,
            accountId,
            sdkUrl,
        });
    }
    listUsers(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { from = 0, size, orderDirection, orderProperty, query } = params;
            return this.callApiV2({
                route: '/users',
                method: 'GET',
                params: {
                    from,
                    size,
                    orderDirection,
                    orderProperty,
                    query,
                },
            });
        });
    }
    getUserById(userId, projection = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = `${this.sdkApi.isCrossAccount ? `accounts/${this.sdkApi.currentAccountId}` : ''}/users/${encodeURIComponent(userId)}`;
            return this.sdkApi.makeRequest({
                route,
                method: 'GET',
                params: {
                    projection,
                },
            });
        });
    }
    getCurrentMultiUserProfile({ validate } = { validate: true }) {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: '/user/multi-user',
            });
            return validate
                ? yield CurrentMultiUserProfile.parseAsync(profile)
                : profile;
        });
    }
    getAccountInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/account',
                method: 'GET',
            });
        });
    }
    listAccountProfiles() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/account/multi-users',
                method: 'GET',
            });
        });
    }
    listProfiles(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                route: '/multi-users',
                method: 'GET',
                params: {
                    email: params.email,
                    username: params.username,
                    id: params.id,
                },
            });
            return makeList(data);
        });
    }
    listUsersAdvanced(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/users/advanced',
                method: 'GET',
                params,
            });
        });
    }
    getProfileById(profileId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                route: `/multi-user/profile/${encodeURIComponent(profileId)}`,
                method: 'GET',
            });
        });
    }
    attachProfile(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                route: `/accounts/${this.currentAccountId || 'current'}/multi-user/attach-start`,
                method: 'POST',
                data: {
                    email: params.email,
                    userId: params.userId,
                    password: params.password,
                },
            });
        });
    }
    listProfileUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                route: '/multi-user/list-users',
                method: 'GET',
            });
        });
    }
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                method: 'GET',
                route: '/auth/token',
            });
        });
    }
    getUserEmail(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: `/users/${userId || 'current'}/email`,
                method: 'GET',
            });
        });
    }
    deleteUser(userId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.sdkApi.makeRequest({
                route: `/accounts/${accountId || 'current'}/users/${userId}`,
                method: 'DELETE',
            });
        });
    }
    userListProfileAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApiV2({
                route: '/multi-users/accounts',
            });
        });
    }
    listAccounts(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.callApiV2({
                route: '/accounts',
                params,
            });
            return {
                total: data.count,
                items: data.rows,
            };
        });
    }
}
//# sourceMappingURL=Users.js.map